'use client';

import { HEAP_APP_ID } from '@m/config/env';
import Script from 'next/script';

const HEAP_SNIPPET =
  'window.heapReadyCb=window.heapReadyCb||[],window.heap=window.heap||[],heap.load=function(e,t){window.heap.envId=e,window.heap.clientConfig=t=t||{},window.heap.clientConfig.shouldFetchServerConfig=!1;var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="https://cdn.us.heap-api.com/config/"+e+"/heap_config.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(a,r);var n=["init","startTracking","stopTracking","track","resetIdentity","identify","identifyHashed","getSessionId","getUserId","getIdentity","addUserProperties","addEventProperties","removeEventProperty","clearEventProperties","addAccountProperties","addAdapter","addTransformer","addTransformerFn","onReady","addPageviewProperties","removePageviewProperty","clearPageviewProperties","trackPageview"],i=function(e){return function(){var t=Array.prototype.slice.call(arguments,0);window.heapReadyCb.push({name:e,fn:function(){heap[e]&&heap[e].apply(heap,t)}})}};for(var p=0;p<n.length;p++)heap[n[p]]=i(n[p])};';

export default function HeapInit({ queueAfterLoad }: { queueAfterLoad?: string }) {
  if (!HEAP_APP_ID) {
    return null;
  }

  return (
    <Script
      id="heap-analytics"
      strategy="beforeInteractive"
      dangerouslySetInnerHTML={{
        // `queueAfterLoad` runs in this same tag, after the stub is installed and before the
        // async SDK can snapshot the automatic pageview.
        __html: `${HEAP_SNIPPET}heap.load("${HEAP_APP_ID}");${queueAfterLoad ?? ''}`,
      }}
    />
  );
}
